module.exports = __webpack_public_path__ + "static/media/29EUNOG7.5f5e3a46.jpg";